import { createFileRoute } from '@tanstack/react-router';
import NoLicense from '../../../info/src/routes/NoLicense';

export const Route = createFileRoute('/_secured/info/no-subscription/$moduleName')({
  component: NoLicense,
});
